import { Component, OnInit, Input, OnDestroy } from '@angular/core';

declare global {
  interface Window {
    _hsq: any[];
  }
}

@Component({
  selector: 'app-feedback-button',
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.css']
})
export class FeedbackButtonComponent implements OnInit, OnDestroy {
  @Input() formId: string = 'ce81a79f-1f24-474c-b585-a14d6d781216'; // Default form ID
  @Input() portalId: string = '3348448'; // Default portal ID
  @Input() region: string = 'na1'; // Default region

  private isHubSpotInitialized: boolean = false;

  ngOnInit() {
    // Initialize HubSpot
    this.initializeHubSpot();
  }

  ngOnDestroy() {
    // Clean up if needed
  }

  private initializeHubSpot() {
    // Check if HubSpot is already loaded
    if (typeof window._hsq !== 'undefined') {
      this.isHubSpotInitialized = true;
      return;
    }

    // Initialize HubSpot tracking code
    window._hsq = window._hsq || [];
    
    // Load HubSpot script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${this.portalId}.js`;
    document.head.appendChild(script);
    
    this.isHubSpotInitialized = true;
  }

  public openFeedbackPopup() {
    // Show the feedback popup
    const popup = document.getElementById('feedback-popup');
    if (popup) {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
      
      // Load HubSpot form after popup is shown
      setTimeout(() => {
        this.loadHubSpotForm();
      }, 100);
    }
  }

  public closeFeedbackPopup() {
    // Hide the feedback popup
    const popup = document.getElementById('feedback-popup');
    if (popup) {
      popup.style.display = 'none';
      document.body.style.overflow = 'auto'; // Restore scrolling
    }
  }

  private loadHubSpotForm() {
    const container = document.getElementById('hubspot-form-container');
    if (!container) return;

    // Clear existing content
    container.innerHTML = '';

    // Create HubSpot form embed script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://js.hsforms.net/forms/embed/${this.portalId}.js`;
    script.defer = true;
    
    // Create the HubSpot form frame div
    const formFrame = document.createElement('div');
    formFrame.className = 'hs-form-frame';
    formFrame.setAttribute('data-region', this.region);
    formFrame.setAttribute('data-form-id', this.formId);
    formFrame.setAttribute('data-portal-id', this.portalId);

    // Add the form frame to container
    container.appendChild(formFrame);
    
    // Add the script to head
    document.head.appendChild(script);
  }
} 


// WEBPACK FOOTER //
// ./src/app/shared/feedback-button.component.ts